import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.access');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    standalone: false,
    selector: 'wiz-page-access',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.access/view.scss */
:host {
  display: block;
  height: 100%;
  min-height: 100vh;
  width: 100%;
  background: #020617;
}`],
})
export class PageAccessComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) { }

    public view: string = 'login';
    public submitting: boolean = false;
    public redirecting: boolean = false;
    public passwordVisible: boolean = false;
    public passwordConfirmVisible: boolean = false;

    public data: any = {
        id: '',
        name: '',
        password: '',
        passwordConfirm: ''
    };

    public async ngOnInit() {
        await this.service.init();
        let check = await this.service.auth.check();
        if (check) {
            await this.redirectToDashboard();
            return;
        }
        await this.service.render();
    }

    public async alert(message: string, status: string = 'error') {
        return await this.service.modal.show({
            title: "",
            message: message,
            cancel: false,
            actionBtn: status,
            action: '확인',
            status: status
        });
    }

    public async switchView(view: string) {
        if (this.submitting || this.redirecting) return;
        this.view = view;
        this.data.password = '';
        this.data.passwordConfirm = '';
        this.passwordVisible = false;
        this.passwordConfirmVisible = false;
        await this.service.render();
    }

    public async togglePasswordVisibility(confirm: boolean = false) {
        if (confirm) {
            this.passwordConfirmVisible = !this.passwordConfirmVisible;
        } else {
            this.passwordVisible = !this.passwordVisible;
        }
        await this.service.render();
    }

    public async submit() {
        if (this.submitting || this.redirecting) return;
        this.submitting = true;
        await this.service.render();
        try {
            if (this.view === 'signup') {
                await this.signup();
                return;
            }
            await this.login();
        } finally {
            if (this.redirecting) return;
            this.submitting = false;
            await this.service.render();
        }
    }

    public async login() {
        let user = JSON.parse(JSON.stringify(this.data));
        if (!user.id) {
            await this.alert("아이디를 입력해주세요.");
            return;
        }
        if (!user.password) {
            await this.alert("비밀번호를 입력해주세요.");
            return;
        }

        // user.password = this.service.auth.hash(user.password);

        let { code, data } = await wiz.call("login", user);

        if (code == 200) {
            this.service.auth.rememberSession();
            await this.redirectToDashboard();
        } else {
            await this.alert(data.message || "로그인에 실패했습니다.", 'error');
            await this.service.render();
        }
    }

    public async signup() {
        let user = JSON.parse(JSON.stringify(this.data));
        if (!user.id) {
            await this.alert("아이디를 입력해주세요.");
            return;
        }
        if (!user.name) {
            await this.alert("이름을 입력해주세요.");
            return;
        }
        if (!user.password) {
            await this.alert("비밀번호를 입력해주세요.");
            return;
        }
        if (user.password !== user.passwordConfirm) {
            await this.alert("비밀번호 확인이 일치하지 않습니다.");
            return;
        }

        let { code, data } = await wiz.call("signup", user);

        if (code == 200) {
            this.service.auth.rememberSession();
            await this.redirectToDashboard();
        } else {
            await this.alert(data.message || "회원가입에 실패했습니다.", 'error');
            await this.service.render();
        }
    }

    private async redirectToDashboard() {
        this.redirecting = true;
        this.submitting = true;
        await this.service.render();
        this.service.href("/dashboard");
    }
}

export default PageAccessComponent;